// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_spinner__fXcPV","keyframe_spinner":"spinner_keyframe_spinner__XucJx"};